var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBareCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.19531 4.04895V2.87012C4.19531 2.4737 4.51667 2.15234 4.91309 2.15234H11.1338C11.5302 2.15234 11.8516 2.4737 11.8516 2.87012V9.09082C11.8516 9.48724 11.5302 9.80859 11.1338 9.80859H9.94166",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.08691 4.19141H2.86621C2.4698 4.19141 2.14844 4.51276 2.14844 4.90918V11.1299C2.14844 11.5263 2.4698 11.8477 2.86621 11.8477H9.08691C9.48333 11.8477 9.80469 11.5263 9.80469 11.1299V4.90918C9.80469 4.51276 9.48333 4.19141 9.08691 4.19141Z",
    stroke: "currentColor",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBareCopy);
export default __webpack_public_path__ + "static/media/bare-copy.1f17998b7d44f98d72452e680b897c49.svg";
export { ForwardRef as ReactComponent };